import { styled } from 'stitches.config'
import { FooterRoot } from 'components/Footer/Footer.styles'
import { Card } from 'components/Card'

export const FaqsRoot = styled('div', {
  backgroundColor: '$secondary-100',

  '&': {
    [`${FooterRoot}`]: {
      borderTop: '12px solid transparent',
      borderBottom: 0,
      borderImage: 'url(/assets/pattern-footer-border-mobile.svg) 30',

      '@bp2': {
        borderImage: 'url(/assets/pattern-footer-border-desktop.svg) 30',
      },
    },
  },
})

export const Wrapper = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  $$headerHeight: '80px',
  $$footerHeight: '373px',
  minHeight: 'calc(100vh - $$headerHeight - $$footerHeight)',
})

export const TitleSection = styled('div', {
  display: 'none',

  '@bp2': {
    display: 'block',
    padding: '0 $14',
    paddingTop: 'calc($$headerHeight + $8)',
  },
})

export const VerticalSeparator = styled('div', {
  width: '1px',
  height: '$10',
  display: 'inline-block',
  backgroundColor: '$secondary-600',
})

export const CardSection = styled('div', {
  padding: '$6 $3 $10',
  maxWidth: '$max',

  '@bp1': {
    padding: '$6 $6 $15',
  },

  '@bp2': {
    padding: '0 $14 $15',
  },
})

export const FAQsCard = styled(Card, {
  width: '100%',
  padding: '$3',
  backgroundColor: '$accent-white',
  border: '1px solid $secondary-600',
  borderRadius: '$4',
  boxShadow: '0px 3px 0px $colors$secondary-600',

  '@bp2': {
    padding: '$4 $5',
  },
})
